import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const ShirtManufacturingInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="Shirt Manufacturing"
    sectionDisplayName="Shirt Manufacturing Section"
    backRoute="/sections/shirt-manufacturing"
  />
);

export default ShirtManufacturingInwardConsignment;
